import React, { useState, useEffect } from 'react';
import { Form, Table, message, Button, DatePicker, Typography } from 'antd';
import styles from '../index.module.less';
import dayjs from 'dayjs';
import { STriggerModal } from 'shj-components';
import { httpAchievementWeekDetails, httpAchievementWeekSave, httpAchievementWeekUpdate } from '@/services/customerServices';
import { Item, TableCellProps, WeekProps } from '../type';

const { RangePicker } = DatePicker;

const EditableCell: React.FC<TableCellProps> = ({
  editing,
  dataIndex,
  title,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = <RangePicker />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name="rangeDate"
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `请输入 ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
const EditableTable: React.FC<any> = (props: any) => {
  const { id, btnDisabled, add } = props;
  const [form] = Form.useForm();
  const [init, setInit] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<Item[]>([]);
  const [editingKey, setEditingKey] = useState<number>(-999999);
  const [performanceCycleMonthId, setPerformanceCycleMonthId] = useState('');

  const isEditing = (record: Item) => record.key === editingKey;

  const edit = (record: Partial<Item> & { key: React.Key }) => {
    form.setFieldsValue({ rangeDate: [], ...record });
    btnDisabled(true);
    setEditingKey(record.key);
  };

  const cancel = (record) => {
    if(!record.id) {
      const newData = data.filter(item => item.key !== record.key)
      setData(newData)
    }
    setEditingKey(-999999);
    btnDisabled(false);
  };

  const addData = (val: any[]) => {
    console.log(val)
    if (val.length == 5) {
      message.error('每个月最多配置五个周！', 6);
    } else {
      const _data = val[val.length - 1] || {};
      let num: string = '一';
      switch (val.length + 1) {
        case 1:
          num = '一';
          break;
        case 2:
          num = '二';
          break;
        case 3:
          num = '三';
          break;
        case 4:
          num = '四';
          break;
        case 5:
          num = '五';
          break;
      }
      val.push({
        key: val.length + 1,
        weekSeq: '第' + num + '周',
        startDate: dayjs(_data.endDate).add(1, 'days').format('YYYY-MM-DD'),
        endDate: dayjs(dayjs(_data.endDate).add(1, 'days').format('YYYY-MM-DD')).endOf('week').format('YYYY-MM-DD'),
        dateString:
          dayjs(_data.endDate).add(1, 'days').format('YYYY-MM-DD') +
          '~' +
          dayjs(dayjs(_data.endDate).add(1, 'days').format('YYYY-MM-DD')).endOf('week').format('YYYY-MM-DD'),
        rangeDate: [
          dayjs(_data.endDate).add(1, 'days'),
          dayjs(dayjs(_data.endDate).add(1, 'days').format('YYYY-MM-DD')).endOf('week'),
        ],
      });
      setData([...val]);
      //   setEditingKey(val.length);
      //   btnDisabled(false);
      edit(val[val.length - 1]);
    }
  };

  /**
   * 保存
   * @param key 
   * @returns 
   */
  const save = async (key: React.Key) => {
    try {
      const row = (await form.validateFields()) as Item;
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);
      if (!row.rangeDate[0] || !row.rangeDate[1]) {
        message.error('请选择完整的开始时间和结束时间', 6);
        return;
      }
      if (
        newData[index - 1] &&
        dayjs(newData[index - 1].endDate)
          .add(1, 'days')
          .format('YYYY-MM-DD') !== row.rangeDate[0].format('YYYY-MM-DD')
      ) {
        message.error('开始时间不是上周结束时间的第二天，请重新选择！', 6);
        return;
      }
      if (row.rangeDate[0].format('YYYY-MM-DD') == row.rangeDate[1].format('YYYY-MM-DD')) {
        message.error('开始时间和结束时间不得为同一天！', 6);
        return;
      }
      const id = newData[index].id ? newData[index].id : ''
      // console.log(newData, row);
      // return;
      setLoading(true)
      if (id) {
        await httpAchievementWeekUpdate({
          id,
          weekSeq: newData[index].weekSeq,
          performanceCycleMonthId: performanceCycleMonthId,
          startDate: row.rangeDate[0].format('YYYY-MM-DD'),
          endDate: row.rangeDate[1].format('YYYY-MM-DD'),
        }).then((response: any) => {
          setLoading(false)
          message.success('成功', 6);
          setRefresh(!refresh);
          setEditingKey(-999999);
          btnDisabled(false);
        })
      } else {
        await httpAchievementWeekSave({
          id,
          weekSeq: newData[index].weekSeq,
          performanceCycleMonthId: performanceCycleMonthId,
          startDate: row.rangeDate[0].format('YYYY-MM-DD'),
          endDate: row.rangeDate[1].format('YYYY-MM-DD'),
        }).then((response: any) => {
          setLoading(false)
          message.success('成功', 6);
          setRefresh(!refresh);
          setEditingKey(-999999);
          btnDisabled(false);
        })

      }
    } catch (errInfo) {
      setLoading(false)
      console.log('Validate Failed:', errInfo);
    }
  };

  const columns = [
    { title: '周次', dataIndex: 'weekSeq', className: 'columnsCenter', width: '120px' },
    {
      title: (
        <span>
          <span style={{ paddingRight: '60px' }}>开始时间</span>~<span style={{ paddingLeft: '60px' }}>结束时间</span>
        </span>
      ),
      dataIndex: 'dateString',
      width: '360px',
      className: 'columnsCenter',
      editable: true,
    },
    {
      title: '操作',
      key: 'action',
      width: '200px',
      className: 'columnsCenter',
      render: (_: any, record: Item) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Button loading={loading} onClick={() => save(record.key)} style={{ marginRight: 8 }}>
              保存
            </Button>
            <Button onClick={() => cancel(record)} style={{ marginRight: 8 }}>
              取消
            </Button>
          </span>
        ) : (
          <Typography.Link disabled={editingKey != -999999} onClick={() => edit(record)}>
            修改
          </Typography.Link>
        );
      },
    },
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: Item) => ({
        record,
        dataIndex: col.dataIndex,
        title: '',
        editing: isEditing(record),
      }),
    };
  });
  useEffect(() => {
    if (!init) {
      setInit(true);
      return;
    }
    addData(data);
  }, [add]);

  useEffect(() => {
    setLoading(true);
    httpAchievementWeekDetails({ performanceCycleMonthId: id }).then((res: any) => {
      const list = res.reverse() || [];
      if (list.length == 5) {
        btnDisabled(true);
      } else {
        btnDisabled(false);
      }
      if (list.length) {
        for (let i = 0; i < list.length; i++) {
          list[i].rangeDate = list[i].startDate ? [dayjs(list[i].startDate), dayjs(list[i].endDate)] : null;
          list[i].dateString = list[i].startDate ? dayjs(list[i].startDate).format('YYYY-MM-DD') + '~' + dayjs(list[i].endDate).format('YYYY-MM-DD') : null;
          switch (list[i].weekSeq) {
            case '第一周':
              list[i].key = 1;
              break;
            case '第二周':
              list[i].key = 2;
              break;
            case '第三周':
              list[i].key = 3;
              break;
            case '第四周':
              list[i].key = 4;
              break;
            case '第五周':
              list[i].key = 5;
              break;
          }
        }
        setData(list);
      } else {
        addData([]);
      }
      setPerformanceCycleMonthId(id);
    }).finally(() => {
      setLoading(false);
    });
  }, [id, refresh]);
  return (
    <Form form={form} component={false}>
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        rowKey="key"
        bordered
        dataSource={data}
        loading={loading}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={{
          onChange: cancel,
        }}
      />
    </Form>
  );
};
const Week: React.FC<WeekProps> = ({ rowData = {}, isVisible, setIsVisible }) => {
  const { id } = rowData;
  const [btn, setBtn] = useState(false);
  const [add, setAdd] = useState(false);
  return (
    <STriggerModal
      destroyOnClose={true}
      width={800}
      title="周次配置"
      cancelText="取消"
      open={isVisible}
      onCancel={() => {
        setIsVisible(false);
      }}
      footer={false}
    >
      <Button
        disabled={btn}
        onClick={() => {
          setAdd(!add);
        }}
        type="primary"
      >
        新增
      </Button>
      <p className={styles.p} style={{margin: '10px 0'}}>
        每个月最多配置<span style={{color: 'red'}}>五个周</span>，开始时间必须为上周结束时间的<span style={{color: 'red'}}>第二天</span>
      </p>
      <EditableTable add={add} btnDisabled={setBtn} id={rowData?.id} />
    </STriggerModal>
  );
};

export default Week;
